;
define("product_list_added_to_cart.tpl", function(){});

